module.exports = __webpack_public_path__ + "static/media/health.0d9c7d3d.png";